import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CryptoService } from './crypto.service';

const URLS_TO_SKIP = [
  'get-ds-order-details',
  'pdas/get-inter-regional-order-tracking',
  'pdas/get-inter-regional-drop-tracking',
  'pdas/get-inter-state-order-tracking',
  'pdas/get-inter-state-drop-tracking',
  'shopify/track-order',
  'profile/deviceinfo/save',
  'driver/get-inter-regional-order-by-token',
  'driver/update-inter-regional-order-drop-status-by-token',
];

export const encryptionInterceptor: HttpInterceptorFn = (request, next) => {
  const crypto = inject(CryptoService);

  if (URLS_TO_SKIP.some((skipUrl) => request.url.includes(skipUrl))) {
    return next(request);
  }

  if (request.headers.get('x-access-token')) {
    if (request.body) {
      const urlArr = request.url.split('/');
      if (urlArr[urlArr.length - 1] !== 'upload-imags-for-PDAS') {
        crypto.postKey = crypto.genrateKey();
        const encryptedBody = crypto.encryptData(
          JSON.stringify(request.body),
          crypto.postKey,
          crypto.base64,
        );
        crypto.decryptData(encryptedBody, crypto.postKey, crypto.base64);
        request = request.clone({
          body: { request: encryptedBody },
        });
      }
    }
  } else if (request.body) {
    if (
      !request.url?.includes('https://graph.facebook.com') &&
      !request.url?.includes('downloadDeliveryAppFromAffiliateLink') &&
      !request.url?.includes('get-affiliate-code')
    ) {
      const str = crypto.genrateRandomKeys(100);
      const encryptedBody = crypto.encryptData(
        JSON.stringify(request.body),
        str,
        null,
      );
      const part1 = str.slice(0, str.length / 2);
      const part2 = str.slice(str.length / 2);

      request = request.clone({
        body: { request: part1 + encryptedBody + part2 },
      });
    }
  }

  return next(request);
};
